// ------------------------------------
// Máscaras
// ------------------------------------
function initInputsMask() {
  if ($.isFunction($.fn.mask)) {
    // Numérico
    $('.number').mask('#');

    // Valor
    $('.money').mask('#.##0,00', { reverse: true });

    // Data
    $('.date').mask('00/00/0000', { clearIfNotMatch: true });

    // Horário
    $('.time').mask('00:00', { clearIfNotMatch: true });

    // CEP
    $('.cep').mask('00000-000', { clearIfNotMatch: true });

    // Cartão de crédito
    $('.card-number').mask('0000 0000 0000 0000', { reverse: true });

    // Validade do cartão de crédito
    $('.card-date').mask('00/00', { clearIfNotMatch: true });

    // CPF
    $('.cpf').mask('000.000.000-00', { clearIfNotMatch: true, reverse: true });

    // CNPJ
    $('.cnpj').mask('00.000.000/0000-00', { clearIfNotMatch: true, reverse: true });

    // CPF
    $('.insc-estadual').mask('00.000.000.000', { reverse: true });

    // Somente letras
    $('.letters').mask('Z', {
      translation: {
        Z: {
          pattern: /([A-Za-z])/,
          recursive: true,
        },
      },
    });

    // CPF OU CNPJ
    const maskCpfCnpj = function (val) {
      return val.replace(/\D/g, '').length > 11 ? '00.000.000/0000-00' : '000.000.000-009';
    };
    const optMaskCpfCnpj = {
      onKeyPress: function (val, e, field, options) {
        field.mask(maskCpfCnpj.apply({}, arguments), options);
      },
    };
    $('.cpf-cnpj').mask(maskCpfCnpj, optMaskCpfCnpj);

    // Telefone (Com 9 dígitos)
    const maskPhoneSP = function (val) {
      return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    };
    const optMaskPhoneSP = {
      onKeyPress: function (val, e, field, options) {
        field.mask(maskPhoneSP.apply({}, arguments), options);
      },
      clearIfNotMatch: true,
    };
    $('.phone').mask(maskPhoneSP, optMaskPhoneSP);
  }
}
initInputsMask();

// ------------------------------------
// Validação (Parsley)
// ------------------------------------
function initFormValidation() {
  if ($.isFunction($.fn.parsley)) {
    // Inicia o validador
    $('.form-validation').parsley({
      errorClass: 'is-invalid',
      successClass: 'is-valid',
      classHandler: function (el) {
        return el.$element.closest('.form-group');
      },
      errorsContainer: function (el) {
        return el.$element.closest('.form-group');
      },
    });
  }
}
if ($.isFunction($.fn.parsley)) {
  initFormValidation();

  // Nome completo
  window.Parsley.addValidator('fullname', {
    validateString: function (value) {
      var value = value.trim().split(' ');
      return value.length > 1;
    },
    messages: {
      'pt-br': 'Digite o nome completo.',
    },
  });

  // Valida CPF
  window.Parsley.addValidator('cpf', {
    validateString: function (value) {
      return isValidCPF(value);
    },
    messages: {
      'pt-br': 'Digite um número de CPF válido.',
    },
  });

  // Valida CNPJ
  window.Parsley.addValidator('cnpj', {
    validateString: function (value) {
      return isValidCNPJ(value);
    },
    messages: {
      'pt-br': 'Digite um número de CNPJ válido.',
    },
  });

  // Valida CPF ou CNPJ
  window.Parsley.addValidator('cpf_cnpj', {
    validateString: function (value) {
      return isValidCPForCNPJ(value);
    },
    messages: {
      'pt-br': 'Digite um número de CPF ou CNPJ válido.',
    },
  });

  // Tamanho do arquivo
  window.Parsley.addValidator('maxfilesize', {
    validateString: function (value, maxSize, parsleyInstance) {
      maxSize = maxSize * 1048576;
      const input = parsleyInstance.$element[0];
      const files = input.files;
      const file = files[0];
      if (files.length == 1 && file.size <= maxSize) {
        return true;
      }
      input.value = '';
      return false;
    },
    requirementType: 'integer',
    messages: {
      'pt-br': 'O arquivo não deve ser maior que %s MB.',
    },
  });

  // Validação externa (Ex: E-mail já cadastrado no sistema)
  window.Parsley.addAsyncValidator('remote', function (resp) {
    console.log('Validação externa: ' + resp.responseText);
    return resp.responseText == 'success';
  });

  // Valida número do cartão de crédito
  window.Parsley.addValidator('creditcard', {
    validateString: function (value) {
      return luhnValidate(value);
    },
    messages: {
      'pt-br': 'Número do cartão inválido.',
    },
  });
}

// ------------------------------------
// Campos dinâmicos
// ------------------------------------
(function () {
  'use strict';

  // Desativa o cache do Ajax
  $.ajaxSetup({ cache: false });

  // Campos dinâmicos
  $('[data-sync-input]').each(function () {
    // Variáveis

    // Campo dinâmico
    const $input = $(this);
    // Campo relativo
    const $relativeInput = $($input.data('sync-input'));
    // Parâmetro do campo relativo
    const parentParam = $input.data('sync-param');
    // URL da ação
    let url = `${$input.data('sync-url')}?${parentParam}=`;
    // Valor cadastrado do campo dinâmico (Update)
    const inputValue = $input.data('sync-value');
    // Parâmetro que ficará no atributo "value" de cada "<option>"
    const optionValue = $input.data('sync-option-value');
    // Parâmetro que ficará dentro de cada "<option>"
    const optionText = $input.data('sync-option-text');
    // Placeholder exibido no campo dinâmico, após o carregamento
    const inputPlaceholder = $input.data('sync-placeholder');

    // Carrega o campo dinâmico ao carregar a página
    loadSyncInput();

    // Evento de alteração do campo relativo
    $relativeInput.on('change', loadSyncInput);

    // Carrega o campo dinâmico
    function loadSyncInput() {
      processingSync();
      // Realiza a requisição dos dados
      $.getJSON(`${url}${$relativeInput.val()}`, function (result) {
        console.log(result);
        if (Array.isArray(result) && result.length > 0) {
          populateInput(result);
        } else {
          resetInput();
        }
        //input.trigger('change');
      }).fail(errorInput);
    }

    // Popula o campo dinâmico com os dados retornados
    function populateInput(list) {
      $input.html('');
      changePlaceholder(inputPlaceholder);
      for (let i = 0, n = list.length; i < n; i++) {
        const selected = inputValue == list[i][optionValue] ? 'selected' : '';
        $input.append(`<option value="${list[i][optionValue]}" ${selected}>${list[i][optionText]}</option>`);
      }
      $input.prop('disabled', false);
    }

    // Ações executadas enquanto a requisição é processada
    function processingSync() {
      $input.prop('disabled', true);
      $input.html('');
      changePlaceholder('Aguarde...');
    }

    // Reseta o campo dinâmico
    function resetInput() {
      $input.html('');
      changePlaceholder(inputPlaceholder);
      $input.prop('disabled', false);
    }

    // Erro na requisição
    function errorInput(resp) {
      console.log(resp);
      resetInput();
    }

    // Altera o placeholder do campo dinâmico
    function changePlaceholder(text) {
      // Select2
      if ($input.hasClass('select2')) {
        $input.append(`<option></option>`);
        setTimeout(() => {
          $(`#select2-${$input.attr('id')}-container .select2-selection__placeholder`).text(text);
        });
      }
      // Select Padrão
      else {
        $input.append(`<option value="" hidden>${text}</option>`);
      }
    }
  });
})();

// ------------------------------------
// Completa Endereço
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const urlApi = urlBase + 'app/wiki/assets/completa_endereco.php';
  const $cep = $('#compl-cep');
  const $cepLoader = $cep.parent('.form-input-loader');
  const $logradouro = $('#compl-logradouro');
  const $numero = $('#compl-numero');
  const $bairro = $('#compl-bairro');
  const $cidade = $('#compl-cidade');
  const $estado = $('#compl-estado');
  const $allAddressInput = $('[id^="compl-"]');
  let address = {};

  // Executa a ação quando o CEP é alterado
  $cep.on('change', getAddress);

  // Obtém o endereço completo
  function getAddress() {
    processingAddress();
    // Realiza a requisição dos dados
    $.getJSON(`${urlApi}?cep=${$cep.val()}`, function (result) {
      console.log(result);
      finishedAddress();
      if (result.cidade) {
        address = result;
        populateAddress();
      } else {
        // CEP não encontrado
        console.log('Não foi possível obter o endereço. Verifique o CEP informado.');
      }
    }).fail(errorAddress);
  }

  // Popula os campos do endereço
  function populateAddress() {
    $logradouro.val(address.logradouro);
    $logradouro.parsley().validate();
    $bairro.val(address.bairro);
    $bairro.parsley().validate();
    $cidade.val(address.cidade);
    $cidade.parsley().validate();
    $estado.val(address.uf);
    $estado.parsley().validate();
    $numero.focus();
  }

  // Ações executadas enquanto a requisição é processada
  function processingAddress() {
    $cepLoader.addClass('active');
    $allAddressInput.prop('disabled', true);
  }

  // Ações executadas quanto a requisição é finalizada
  function finishedAddress() {
    $cepLoader.removeClass('active');
    $allAddressInput.prop('disabled', false);
  }

  // Erro na requisição do endereço
  function errorAddress(resp) {
    finishedAddress();
    console.log(resp);
  }
})();

// ------------------------------------
// Contador de Caracteres
// ------------------------------------
(function () {
  'use strict';

  // Campos
  const $inputs = $('.form-input[data-char-count]');

  // Contador
  $inputs.each(function () {
    const $input = $(this);
    const limit = $input.attr('maxlength');
    let count = $input.val().length;
    $input.after('<div class="char-counter"></div>');
    const $countEl = $input.next('.char-counter');
    $countEl.text(count + '/' + limit);
    validateLimit();
    $input.on('keyup keydown keypress', function () {
      count = $(this).val().length;
      $countEl.text(count + '/' + limit);
      validateLimit();
    });
    function validateLimit() {
      if (count >= limit) {
        $countEl.addClass('invalid');
      } else {
        $countEl.removeClass('invalid');
      }
    }
  });
})();

// ------------------------------------
// Grupo de Botões (Radio/Checkbox)
// ------------------------------------
(function () {
  'use strict';

  $('.btn-group-toggle input').on('change', function () {
    handleBtnGroupToggle();
  });

  function handleBtnGroupToggle() {
    $('.btn-group-toggle').each(function () {
      const $btnGroup = $(this);
      const $inputChecked = $btnGroup.find('input:checked');
      const $btn = $inputChecked.parent('.btn');
      $btnGroup.find('.btn').removeClass('active');
      $btn.addClass('active');
    });
  }
  if ($('.btn-group-toggle').length) {
    handleBtnGroupToggle();
  }
})();

// ------------------------------------
// Campo clipboard
// ------------------------------------
(function () {
  'use strict';
  const $btnCopy = $('.btn-clipboard');
  $btnCopy.each(function () {
    const $btn = $(this);
    const tippyInstance = $btn[0]._tippy;
    const tippyContent = $btn.data('tippy-content');
    $btn
      .on('click', function (ev) {
        ev.preventDefault();
      })
      .on('mouseout', function () {
        tippyInstance.setContent(tippyContent);
      });
    const clipboardBtn = new ClipboardJS('.btn-clipboard');
    clipboardBtn.on('success', function (ev) {
      const $btn = $(ev.trigger);
      tippyInstance.setContent('Copiado!');
      tippyInstance.show();
    });
  });
})();
